import { http, HttpResponse } from 'msw';

import { MockServiceWorker } from '../mockServiceWorker';

export const getNextState = (currentState: string) => {
    switch (currentState) {
        case 'ACCEPT_OFFER_MAIN_APPLICANT':
            return 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT';
        case 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT':
            return 'PPI_MAIN_APPLICANT';
        case 'PPI_MAIN_APPLICANT':
            return 'COMPLEMENT_INFORMATION_CONSOLIDATIONS';
        case 'COMPLEMENT_INFORMATION_CONSOLIDATIONS':
            return 'COMPLEMENT_INFORMATION_MAIN_APPLICANT';
        case 'COMPLEMENT_INFORMATION_MAIN_APPLICANT':
            return 'KYC_MAIN_APPLICANT';
        case 'KYC_MAIN_APPLICANT':
            return 'SIGN_AGREEMENT';
        default:
            return 'APPLICATION_COMPLETE';
    }
};

export const getNextStateCoApplicant = (currentState: string) => {
    switch (currentState) {
        case 'CO_SUBMIT':
            return 'KYC_CO_APPLICANT';
        case 'KYC_CO_APPLICANT':
            return 'SIGN_AGREEMENT';
        default:
            return 'APPLICATION_COMPLETE';
    }
};

export const patchApplicationHandlers = [
    // :languageCode is constrained to two uppercase letters (real LanguageCode values are all shaped this
    // way) so this doesn't also swallow other single-segment PATCH .../application/:arn/<segment> requests,
    // e.g. patchExternalConsentService's .../application/:arn/external_consent, which has no mock of its own
    // and should fall through unhandled. Can't use a `|`-alternation of the exact codes here -- MSW's own
    // cleanUrl() treats `|` as a query-string-like separator and truncates the pattern at the first one,
    // which corrupts the regex group into an unbalanced, unmatchable pattern for every handler behind it.
    http.patch(
        '*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/:languageCode([A-Z]{2})',
        async ({ request }) => {
            const application = await request.json();
            const currentState = (application as any).values['CURRENT_APPLICATION_STATE_KEY'];

            const session = MockServiceWorker.getMockedSession();
            if (MockServiceWorker.isMainApplicant()) {
                session.state = getNextState(currentState);
            } else {
                session.state = getNextStateCoApplicant(currentState);
            }
            MockServiceWorker.setMockedSession(session);

            return HttpResponse.json({});
        },
    ),
];
